mutation testTemplate($id: String!, $to_address: String, $language: String, $testCode: String) {
    testTemplate(id: $id, to_address: $to_address, language: $language, testCode: $testCode)
}
